<template>
	<div class="activity_logs">
	  <div v-if="loaded">
		<div v-if="activities.length > 0">
			<div v-for="activity in activities" :key="'activity-' + activity.id" class="card border-secondary mb-3">
			    <div v-if="activity.subject_type === 'App\\Annotation'">
			    	<div class="card-body py-3">
				    	<span>{{ __('translations.activity_log.annotation_' + activity.description) }}</span>
				    </div>
					<div v-if="activity.description === 'created' || activity.description === 'deleted'" class="mb-3 text-center">
						<div v-lazyload class="image-wrapper">
						    <div class="image-loader d-flex justify-content-center" style="height: 100%">
							    <div class="spinner-border text-secondary my-auto" role="status">
								  	<span class="sr-only">Loading...</span>
								</div>
							</div>
							<img :data-url="artifact.iiif_root + '/' + activity.properties.attributes.box_x + ',' + activity.properties.attributes.box_y + ',' + activity.properties.attributes.box_w + ',' + activity.properties.attributes.box_h + '/' + Math.min(activity.properties.attributes.box_w, 400) + ',/0/default.jpg'" class="image-item" style="padding: 0 1.25rem;">
						</div>
						<div class="d-flex flex-row mt-3" v-if="activity.properties.attributes.transcription !== null && activity.properties.attributes.transcription !== ''" style="padding-left: 1.25rem; padding-right: 1.25rem">
						  <div class="text-muted mr-3"><i class="fas fa-font"></i></div>
						  <div class="text-preformatted flex-grow text-left">{{ activity.properties.attributes.transcription }}</div>
						</div>
					</div>
					<div v-else-if="activity.description === 'updated'" class="mb-3 text-center">
						<div class="row">
	  						<div class="col-sm-6 text-success mb-1"><div>{{ __('translations.activity_log.new') }}</div></div>
	  						<div class="col-sm-6 text-danger mb-1"><div>{{ __('translations.activity_log.old') }}</div></div>
						</div>
						<div class="row">
	  						<div class="col-sm-6" style="border-right: 1px solid rgba(0, 0, 0, 0.125);">
	  							<div v-lazyload class="image-wrapper">
								    <div class="image-loader d-flex justify-content-center" style="height: 100%">
									    <div class="spinner-border text-secondary my-auto" role="status">
										  	<span class="sr-only">Loading...</span>
										</div>
									</div>
									<img :data-url="artifact.iiif_root + '/' + activity.properties.attributes.box_x + ',' + activity.properties.attributes.box_y + ',' + activity.properties.attributes.box_w + ',' + activity.properties.attributes.box_h + '/' + Math.min(activity.properties.attributes.box_w, 400) + ',/0/default.jpg'" class="image-item" style="padding-left:1.25rem; padding-right:0.25rem;">
								</div>
	  							<div class="d-flex flex-row mt-3" v-if="activity.properties.attributes.transcription !== null && activity.properties.attributes.transcription !== ''" style="padding-left: 1.25rem; padding-right: 0.25rem">
								  <div class="text-muted mr-3"><i class="fas fa-font"></i></div>
								  <div class="text-preformatted flex-grow text-left">{{ activity.properties.attributes.transcription }}</div>
								</div>
	  						</div>
	  						<div class="col-sm-6">
	  							<div v-lazyload class="image-wrapper">
								    <div class="image-loader d-flex justify-content-center" style="height: 100%">
									    <div class="spinner-border text-secondary my-auto" role="status">
										  	<span class="sr-only">Loading...</span>
										</div>
									</div>
									<img :data-url="artifact.iiif_root + '/' + activity.properties.old.box_x + ',' + activity.properties.old.box_y + ',' + activity.properties.old.box_w + ',' + activity.properties.old.box_h + '/' + Math.min(activity.properties.old.box_w, 400) + ',/0/default.jpg'" class="image-item" style="padding-left: 0.25rem; padding-right: 1.25rem;">
								</div>
	  							
	  							<div class="d-flex flex-row mt-3" v-if="activity.properties.old.transcription !== null && activity.properties.old.transcription !== ''" style="padding-left: 0.25rem; padding-right: 1.25rem">
								  <div class="text-muted mr-3"><i class="fas fa-font"></i></div>
								  <div class="text-preformatted strikethrough-text flex-grow text-left">{{ activity.properties.old.transcription }}</div>
								</div>
	  						</div>
						</div>
					</div>
				</div>
				<div v-if="activity.subject_type === 'App\\WikidataTag'">
					<div v-if="activity.properties.taggable_type === 'App\\Image'">
						<div class="card-body py-3">
					    	<span>{{ __('translations.activity_log.tag_' + activity.description) }}&nbsp;<b class="font-italic" :class="{'strikethrough-text' : activity.description === 'deleted'}">{{ activity.properties.attributes.wikidata_label }}</b></span>
					    </div>
					</div>
					<div v-else-if="activity.properties.taggable_type === 'App\\Annotation'">
						<div class="card-body py-3">
					    	<span>{{ __('translations.activity_log.tag_' + activity.description) }}&nbsp;<b class="font-italic" :class="{'strikethrough-text' : activity.description === 'deleted'}">{{ activity.properties.attributes.wikidata_label }}</b></span>
					    </div>
					    <div class="mb-3 text-center">
					    	<div v-lazyload class="image-wrapper">
							    <div class="image-loader d-flex justify-content-center">
								    <div class="spinner-border text-secondary my-auto" role="status">
									  	<span class="sr-only">Loading...</span>
									</div>
								</div>
								<img :data-url="artifact.iiif_root + '/' + activity.properties.annotation.box_x + ',' + activity.properties.annotation.box_y + ',' + activity.properties.annotation.box_w + ',' + activity.properties.annotation.box_h + '/' + Math.min(activity.properties.annotation.box_w, 400) + ',/0/default.jpg'" class="image-item" style="padding: 0 1.25rem;">
							</div>
						</div>
					</div>
				</div>
				<div class="card-footer d-flex justify-content-between" style="line-height: 0.9rem;">
				    <small class="text-muted">{{ formatDate(activity.created_at) }}&nbsp;{{ __('translations.activity_log.at') }}&nbsp;{{ formatTime(activity.created_at) }}</small>
				    <small v-if="activity.causer !== null">{{ __('translations.activity_log.by') }}&nbsp;{{ activity.causer.name }}</small>
				    <small v-else>{{ __('translations.activity_log.by') }}&nbsp;{{ __('translations.activity_log.system') }}</small>
			    </div>
			</div>
		  </div>
		  <div v-else class="text-muted">
		  	{{ __('translations.activity_log.no_activities_found') }}
		  </div>
	  </div>
	</div>
</template>

<script>
var moment = require('moment');
import LazyLoadDirective from '../directives/LazyLoadDirective';

export default {
	name: 'ActivityLogs',
	directives: {
		lazyload: LazyLoadDirective
	},
	props: ['artifact'],
	data() {
		return {
			activities: [],
			loaded: false
		}
	},
	async created() {
		await axios.post('/activities', {artifact_id: this.artifact.id, artifact_type: this.artifact.type}).then(response => {
			this.activities = response.data;
			this.loaded = true;
		}).catch(error => {
			console.log(error);
		});
	},
	methods: {
		formatDate(date) {
			return moment(date).format('DD.MM.YYYY');
		},
		formatTime(date) {
			return moment(date).format('HH:mm');
		}
	}
}
</script>